import get from "lodash.get";

export function alertTypeFormatter(cell, row) {
  return get(row, "attributes.ruleTemplateDescription", "");
}
